import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import AsyncStorage from '@react-native-community/async-storage';

import api from '~/services/api';
import { push } from '~/services/history';

import * as authActions from '~/store/modules/auth/auth-actions';

import { ISA_ORIGINAL_USER_TOKEN, ISA_TOKEN, ISA_USER, ISA_USER_SELECTED_FOR_CONTEXT } from '~/constants';

import { ChangeContextModal } from '../ChangeContextModal';
import { Button } from '@material-ui/core';
import { AppStateType } from '~/store/modules/root-reducer';
import { ArrowBack, Person } from '@material-ui/icons';
import notification from '~/services/notification';
import * as notificationsActions from '~/store/modules/notifications/notifications-actions';

export const ChangeContext = () => {
  const { user } = useSelector((state: AppStateType) => state.auth);
  const dispatch = useDispatch();

  const [showChangeCtxModal, setShowChangeCtxModal] = useState(false);
  const [, setCtxSelected] = useState('');

  const handleReturnToOriginalUser = async () => {
    const originalUser = await AsyncStorage.getItem(ISA_USER);
    const originalUserToken = await AsyncStorage.getItem(ISA_ORIGINAL_USER_TOKEN);

    await AsyncStorage.setItem(ISA_TOKEN, originalUserToken);
    await AsyncStorage.removeItem(ISA_USER_SELECTED_FOR_CONTEXT);

    dispatch(authActions.setUserSelectedForContext({ ...JSON.parse(originalUser), token: originalUserToken }));
    dispatch(notificationsActions.getAllRequest());

    push('/dashboard/analytics');
    notification.success('Retornado ao usuário original com sucesso');
  };

  const handleChangeCtx = async (ctx: string) => {
    setCtxSelected(ctx);
    setShowChangeCtxModal(false);

    try {
      const { data } = await api.post(`/auth/changeUserContext`, {
        newUserExternalCode: ctx
      });

      const parsedUser = {
        ...data.payload,
        token: data?.token,
        originalUserExternalCode: data.payload.originalUserExternalCode || user?.email
      };

      await AsyncStorage.setItem(ISA_USER_SELECTED_FOR_CONTEXT, JSON.stringify(parsedUser));
      await AsyncStorage.setItem(ISA_TOKEN, data?.token);

      dispatch(authActions.setUserSelectedForContext(parsedUser));
      dispatch(notificationsActions.getAllRequest());

      push('/dashboard/analytics');
      notification.success('Usuário selecionado com sucesso');
    } catch (error) {
      await AsyncStorage.removeItem(ISA_USER_SELECTED_FOR_CONTEXT);

      dispatch(authActions.setUserSelectedForContext(null));
      notification.error('Erro ao selecionar usuário');
    }
  };

  return (
    <>
      {user?.originalUserExternalCode && (
        <Button onClick={handleReturnToOriginalUser} startIcon={<ArrowBack />}>
          Retornar ao usuário original
        </Button>
      )}

      {!user?.originalUserExternalCode && (
        <Button onClick={() => setShowChangeCtxModal(true)} startIcon={<Person />}>
          Selecionar usuário
        </Button>
      )}

      <ChangeContextModal
        showChangeCtxModal={showChangeCtxModal}
        setShowChangeCtxModal={setShowChangeCtxModal}
        setCtxSelected={setCtxSelected}
        onChangeCtx={handleChangeCtx}
      />
    </>
  );
};
